import styled from"@emotion/styled";import{FlexLayout}from"@wp/src/components/common/grid";export const NetworthPortfoliosContainer=styled.div`
  border: 1px solid ${props=>props.theme.colors.neutral300};
  box-sizing: border-box;
  border-radius: 0 0 8px 8px;
  overflow: auto;
`;export const CurrentPortfolioMainContainer=styled.div`
  box-shadow: inset 0px -1px 0px ${props=>props.theme.colors.neutral300};
  padding: 16px;
  box-sizing: border-box;
`;export const CurrentPortfolioContainer=styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  ${props=>props.isConnectedAccount?"padding-right: 0px !important;":""}
`;export const CurrentPortfolioContentWrapper=styled.div`
  display: flex;
  width: 100%;
`;export const CurrentPortfolioContent=styled(FlexLayout)``;export const OnboardingCurrentPortfolioContent=styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  row-gap: 8px;
`;export const PortfolioTitle=styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${props=>props.theme.colors.neutral800};
  display: flex;
  column-gap: 4px;
  align-items: center;
`;export const PortfolioDescription=styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  column-gap: 8px;
  align-content: center;
  font-size: 14px;
  color: ${props=>props.theme.colors.neutral500};
`;export const PortfolioDescriptionItem=styled.span``;export const PortfolioAmountContainer=styled.span`
  font-weight: 400;
`;export const PortfolioActionsContainer=styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;export const AggregatedPortfoliosContainer=styled.div`
  & > div:last-child {
    box-shadow: inset 0px -1px 0px ${props=>props.theme.colors.neutral300};
  }
`;export const AggregatedMainPortfolios=styled.div`
  box-shadow: inset 0px -1px 0px ${props=>props.theme.colors.neutral300};
  padding: 16px;
`;export const AggregatedPortfoliosHeader=styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  column-gap: 16px;
`;export const AggregatedPortfoliosHeaderTitle=styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  font-weight: 500;
  font-size: 16px;
`;export const InvestmentAccountsActionsContainer=styled.div`
  padding: 0 16px;
`;